// extracted by mini-css-extract-plugin
export var border = "_p-7";
export var brand = "_p-r";
export var button = "_p-j";
export var center = "_p-9";
export var centered = "_p-5";
export var closeButton = "_p-b";
export var disabledWrapper = "_p-k";
export var error = "_p-n";
export var extraLarge = "_p-4";
export var extraSmall = "_p-1";
export var fill = "_p-g";
export var footer = "_p-f";
export var footerAction = "_p-h";
export var footerButtons = "_p-i";
export var header = "_p-6";
export var icon = "_p-m";
export var info = "_p-q";
export var inline = "_p-8";
export var large = "_p-3";
export var main = "_p-c";
export var modal = "_p-0";
export var neutral = "_p-s";
export var noPadding = "_p-e";
export var none = "_p-t";
export var scrollable = "_p-d";
export var small = "_p-2";
export var success = "_p-p";
export var tight = "_p-l";
export var titleIcon = "_p-a";
export var warn = "_p-o";